// extracted by mini-css-extract-plugin
export var twoColWrap = "twoColMailChimpForm-module--twoColWrap--ZHLIM";
export var twoColMailChimpFormInset = "twoColMailChimpForm-module--twoColMailChimpFormInset--fBsvC";
export var twoColWrapLeftCol = "twoColMailChimpForm-module--twoColWrapLeftCol--0Rsoy";
export var twoColWrapRightCol = "twoColMailChimpForm-module--twoColWrapRightCol--a0Uos";
export var mcEmbedSignupWrap = "twoColMailChimpForm-module--mcEmbedSignupWrap--8e3tw";
export var rightColCalloutHeading = "twoColMailChimpForm-module--rightColCalloutHeading--qwueE";
export var rightColCalloutSubtitle = "twoColMailChimpForm-module--rightColCalloutSubtitle--GvbQX";
export var rightColCalloutText = "twoColMailChimpForm-module--rightColCalloutText--TB0LE";
export var form = "twoColMailChimpForm-module--form--OjOZ4";
export var logo = "twoColMailChimpForm-module--logo--dy5Ba";
export var smallGreyText = "twoColMailChimpForm-module--smallGreyText--2v4RD";
export var smallHeader = "twoColMailChimpForm-module--smallHeader--JtECJ";
export var largeText = "twoColMailChimpForm-module--largeText--iwwIq";
export var textBlock = "twoColMailChimpForm-module--textBlock--dR9yQ";
export var inputGroup = "twoColMailChimpForm-module--inputGroup--atThH";
export var spacer = "twoColMailChimpForm-module--spacer--zvaWt";
export var navSocial = "twoColMailChimpForm-module--navSocial--cBVAG";
export var emailInput = "twoColMailChimpForm-module--emailInput--Lje9P";
export var textInput = "twoColMailChimpForm-module--textInput--2-THL";
export var submitButton = "twoColMailChimpForm-module--submitButton--hgniI";
export var errorResponse = "twoColMailChimpForm-module--errorResponse--ItR+6";
export var footer = "twoColMailChimpForm-module--footer--yFdjd";
export var slideUp = "twoColMailChimpForm-module--slideUp--3UGi6";
export var slideUpLarge = "twoColMailChimpForm-module--slideUpLarge--99EWu";